// User-related type definitions

export interface UserSettings {
  defaultOrgId: string;
  defaultTimezoneInfo: string;
  theme: string;
}

export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  settings: UserSettings;
  role?: string;
  isSuperAdmin?: boolean;
  isPending?: boolean;
  invitedDate?: string;
  invitationExpires?: string;
  // tenantId?: string;
  getInitials(): string;
}

export interface ISession {
  user: User;
  currentOrg?: IOrg;
  currentOrgId: string;
  currentOrgName: string;
  isAuthenticated: boolean;
  isSuperAdmin?: boolean;
  role?: string;
  // The OAuth redirect URI for this environment — users register it with their provider when
  // setting up an oauth2-authcode / vendor-initiated connection. Null if the server has no base URL.
  connectionCallbackUrl?: string | null;
  // True only for password (CIAM) users — SSO users have no BlackBox-managed password.
  canChangePassword?: boolean;
}

export interface IOrg {
  orgId: string;
  orgName: string;
  canPublishProducts?: boolean;
  canPartnerWithOrgs?: boolean;
  projectCount?: number;
  primaryContactUserId?: string;
}

export class User implements IUser {
  id = "";
  firstName = "";
  lastName = "";
  email = "";
  settings: UserSettings = {
    defaultOrgId: "",
    defaultTimezoneInfo: "",
    theme: "",
  };
  initials = "";
  role?: string;
  isSuperAdmin?: boolean;
  isPending?: boolean;
  invitedDate?: string;
  invitationExpires?: string;
  // tenantId?: string;

  constructor(data?: IUser) {
    if (data) {
      Object.assign(this, data);
      this.settings = { ...data.settings };
    } else {
      this.id = "";
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.settings = { defaultOrgId: "", defaultTimezoneInfo: "", theme: "" };
    }
    this.initials = this.getInitials();
  }

  getInitials() {
    if (!this.firstName && !this.lastName) {
      // For pending users without names, use email
      return this.email ? this.email.substring(0, 2).toUpperCase() : "?";
    }
    return this.firstName.charAt(0) + this.lastName.charAt(0);
  }
}
